const init = {
    loading: false,
    roadSpecialEvents: null,
    error: undefined,
    isSaved: false
  };
  
  export const roadSpecialEvents = (state = init, action) => {
    switch (action.type) {
      case "FETCH_ROAD_SPECIAL_EVENTS_START":
        return { ...state, loading: true,isSaved:false };
      case "FETCH_ROAD_SPECIAL_EVENTS_SUCCESS":
        return { ...state, loading: false, roadSpecialEvents: action.payload };
      case "FETCH_ROAD_SPECIAL_EVENTS_FAILURE":
        return { ...state, loading: false, error: action.payload };
      case "SAVE_ROAD_SPECIAL_EVENTS_START":
        return { ...state, loading: true, isSaved: false };
      case "SAVE_ROAD_SPECIAL_EVENTS_SUCCESS":
        return { ...state, loading: false, isSaved: true,error:undefined };
      case "SAVE_ROAD_SPECIAL_EVENTS_FAILURE":
        return { ...state, loading: false, error: action.payload,isSaved:false };
      default:
        return state;
    }
  };
  